// extracted by mini-css-extract-plugin
module.exports = {"League-Messages--container":"LeagueMessages_League-Messages--container__azbRF"};